/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ tld: NonNullable<unknown> }} Reseller_Pricing_Enabled_OnInputs */

const id_reseller_pricing_enabled_on = /** @type {(inputs: Reseller_Pricing_Enabled_OnInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.tld} diaktifkan.`)
};

const en_reseller_pricing_enabled_on = /** @type {(inputs: Reseller_Pricing_Enabled_OnInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.tld} is on sale.`)
};

/**
* | output |
* | --- |
* | "{tld} is on sale." |
*
* @param {Reseller_Pricing_Enabled_OnInputs} inputs
* @param {{ locale?: "id" | "en" }} options
* @returns {LocalizedString}
*/
export const reseller_pricing_enabled_on = /** @type {((inputs: Reseller_Pricing_Enabled_OnInputs, options?: { locale?: "id" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Reseller_Pricing_Enabled_OnInputs, { locale?: "id" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_reseller_pricing_enabled_on(inputs)
	return id_reseller_pricing_enabled_on(inputs)
});